module.exports = __webpack_public_path__ + "static/media/referredAdmin.4877158e.png";